// extracted by mini-css-extract-plugin
export var form = "style-module--form--1mXQb";
export var form_inputs = "style-module--form_inputs--2rni3";
export var form_submit = "style-module--form_submit--2xOXl";
export var form_submit_btn = "style-module--form_submit_btn--2HU-_";